import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import FullPage from "../../components/FullPage";
import BemVindo from "./Section/BemVindoSomaPlace";
import useSomaPlaceUser from "../../Hooks/SomaPlaceContext";
import CadastroUsuarioSomaPlace from "./Section/CadastroUsuarioSomaPlace";
import ContratosAceitos from "./Section/ContratosAceitos";
import SomaPlaceService from "../../Services/SomaPlace/index";

const SomaPlacePage = (props) => {
  let match = useRouteMatch();
  const { somaPlaceUser } = useSomaPlaceUser();

  //Para realizar a verificação se o usuário pode utilizar o soma place foi adicionado a variável de estado
  //accessSomaPlace inicialmente com o valor undefined. Quando a página inicia o método checkAccessSomaPlace é chamado,
  //neste será feito uma verificação no endpoint se o usuário atual é um testador (isTester) ou se o acesso já esta
  //aberto (open), se uma dessas verificações forem verdadeiras, accessSomaPlace será true e o usuário poderá acessar
  //as funcionalidades do Soma Place, se não forem a função history.goBack() será executada em useEffect.

  //Váriavel de estado para verificar o acesso ao usuário ao SomaPlace
  const [accessSomaPlace, setAccessSomaPlace] = useState(undefined);

  //const [isSomaPlaceUser, setIsSomaPlaceUser] = useState(false);

  const history = useHistory();

  //Função que verifica se o usuário pode acessar o SomaPlace
  const checkAccessSomaPlace = useCallback(async () => {
    const r = await SomaPlaceService.SomaPlace.checkAccessSomaPlace();
    if (r.data) {
      //Condição para acesso.
      if (r.data.isTester || r.data.open) {
        setAccessSomaPlace(true);
        return;
      }
    }
    //Condição para chamar o history.goBack.
    setAccessSomaPlace(false);
  }, []);

  useEffect(() => {
    // Chamada da função
    checkAccessSomaPlace();
    // Verificação da função, useEffect será chamado quando houver mudança de estado na variável accessSomaPlace
    if (accessSomaPlace === false) {
      history.goBack();
    }
    if (somaPlaceUser) {
      //setIsSomaPlaceUser(true);
    }
  }, [accessSomaPlace, checkAccessSomaPlace, history, somaPlaceUser]);


  let config = {
    parentUrl: match.path,
    parentName: "SOMAPLACE",
    parentComponent: BemVindo,
    routes: [
      { 
        route: "register", 
        text: "CADASTRAR", 
        component: CadastroUsuarioSomaPlace 
      },
      {
        route: "my-register",
        text: "MEU CADASTRO",
        component: CadastroUsuarioSomaPlace
      },
      {
        route: "contracts",
        text: "CONTRATOS ACEITOS",
        component: ContratosAceitos
      },
    ],
  };

  return <FullPage {...config} />;
};

export default SomaPlacePage;
